import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { QText } from './index';
import SingleRightArrow from './Icons/SingleRightArrow';
import { useTheme } from 'react-native-paper';
import { makeStyles } from '../hooks/MakeStylesHook';

const SimpleQueueCard = ({ queueName, onPress }) => {
  const theme = useTheme();
  const styles = useStyles();

  return (
    <TouchableOpacity
      style={styles.listItem}
      onPress={onPress}
      activeOpacity={0.8}
    >
      <View style={styles.listContent}>
        <QText
          style={[styles.queueName, { color: theme.colors.secondaryText }]}
        >
          {queueName}
        </QText>
        <SingleRightArrow
          width={20}
          height={20}
          color={theme.colors.disabledIconColor}
        />
      </View>
      <View
        style={[
          styles.dividerLine,
          { backgroundColor: theme.colors.OnBackgroundDarkBorder },
        ]}
      />
    </TouchableOpacity>
  );
};

const useStyles = makeStyles((theme) => ({
  listItem: {
    width: '100%',
    paddingVertical: 16,
    paddingHorizontal: 0,
  },
  listContent: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: 8,
  },
  queueName: {
    fontSize: 16,
    fontWeight: 500,
    textTransform: 'capitalize',
    flex: 1,
  },
  dividerLine: {
    height: 1,
    width: '100%',
  },
}));

export default SimpleQueueCard;
